import { getRuntimeConfig } from 'helpers/runtimeConfig';

const Auth = () => ({
  Auth: {
    // this auth type allows for user migration with Lambda
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    mandatorySignIn: false,
    cookieStorage: {
      domain: getRuntimeConfig().env.REACT_APP_COGNITO_COOKIE_DOMAIN,
      path: '/',
      expires: 365,
      secure: true,
    },
  },
});

export default Auth;
